var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"label d-flex pl-2",attrs:{"color":_vm.backColor,"elevation":"0","tile":""}},[_c('span',{staticClass:"my-auto label-text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }